import { TranslocoService } from '@ngneat/transloco';
import { CommonWordingPipe, TranslocoErrorSpecification, icoCloudOff } from '@platform-frontend/ui-tools';
import { PLATFORM_TRANSLOCO_SCOPE } from '../platform-transloco-scope';

export const ERR_SERVER_UNREACHABLE = (translocoService: TranslocoService, buttonClick: string | (() => void) | null): TranslocoErrorSpecification => ({
  type: 'transloco',
  buttonClick,
  buttonName: new CommonWordingPipe(translocoService).transform('tryAgain'),
  descriptions: [
    {
      key: 'platform.errorSpecification.errServerUnreachable.description',
      scope: PLATFORM_TRANSLOCO_SCOPE
    }
  ],
  icon: icoCloudOff,
  title: translocoService.selectTranslate('errorSpecification.errServerUnreachable.title', {}, PLATFORM_TRANSLOCO_SCOPE),
  forErrorTypes: ['SERVER_UNREACHABLE']
});

export const ERR_SPECS_FOR_ERROR_TYPES = (translocoService: TranslocoService, tryAgainButtonClick?: string | (() => void)): TranslocoErrorSpecification[] => [
  ERR_SERVER_UNREACHABLE(translocoService, tryAgainButtonClick ?? null)
];
